import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Module} from '../../../models/models';
import {Translation} from '../../../models/translation';
import {LoginService} from '../../../services/login.service';
import {CheckService} from '../../../services/check.service';
import {DamageAdministrationService} from 'src/app/services/damage-administration.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-damage-case',
  templateUrl: './damage-case.component.html',
  styleUrls: ['./damage-case.component.css'],
})
export class DamageCase implements OnInit {

  public translation: Translation;
  public damageCaseRecordModule: Module;
  public damageCaseOpenModule: Module;
  public damageCaseClosedModule: Module;

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
      private loginService: LoginService,
      private checkService: CheckService,
      private router: Router,
      private damageAdministrationService: DamageAdministrationService
    ) { }
    navigate(forwardLink: string) {
      this.router.navigate([forwardLink]);
    }
    ngOnInit() {
      window.scrollTo(0, 0);
      this.loginService.checkToken();
      this.checkService.checkModule(10);
      this.translation = JSON.parse(localStorage.getItem('Translation'));

      this.damageAdministrationService.getDamageCasesWithNewFeed(+sessionStorage.getItem('PrimaryAddressId')).subscribe(response => {
        if (response.Ok) {
          this.damageCaseRecordModule = new Module();
          this.damageCaseRecordModule.ModuleName = this.translation.New;
          this.damageCaseRecordModule.ModuleDesc = this.translation.ReportNewDamageCase;
          this.damageCaseRecordModule.ModuleButtonText = this.translation.Go;
          this.damageCaseRecordModule.ForwardLink = '/damage-case-record';
          
          this.damageCaseOpenModule = new Module();
          this.damageCaseOpenModule.ModuleName = this.translation.Open;
          this.damageCaseOpenModule.ModuleDesc =  this.translation.EditAndViewDamageCases;
          this.damageCaseOpenModule.ModuleButtonText = this.translation.Go;
          this.damageCaseOpenModule.ForwardLink = '/damage-case-open';
          this.damageCaseOpenModule.Counter = response.Obj[0];

          this.damageCaseClosedModule = new Module();
          this.damageCaseClosedModule.ModuleName = this.translation.Completed;
          this.damageCaseClosedModule.ModuleDesc = this.translation.OverviewClosedDamageCases;
          this.damageCaseClosedModule.ModuleButtonText = this.translation.Go;
          this.damageCaseClosedModule.ForwardLink = '/damage-case-closed';
          this.damageCaseClosedModule.Counter = response.Obj[1];
        }
        if (response.Msg === 'Internal Server Error') console.log(response.Ex);
        if (response.Msg) this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'});
      }), error => this.toast.fire(this.translation.InternalServerError, '', 'error');
    }
  }